import {
  LocationSelectorFormFieldDocument,
  LocationSelectorFormFieldQuery,
} from 'generated/resources/graphql'

import {
  createGraphqlDataSourceDefinition,
  useGraphqlDataSource,
} from 'modules/core/hooks/useGraphqlDataSource'

export type LocationRecord = {
  id: number
  name: string
}

const locationSelectorSourceDefinition = createGraphqlDataSourceDefinition({
  document: LocationSelectorFormFieldDocument,
  paginationType: 'infinite-scroll',
  perPage: 20,
  mapVariables: ({ search }) => ({
    search: search || undefined,
  }),
  mapData: (data: LocationSelectorFormFieldQuery): LocationRecord[] =>
    data.locations?.locationsConnection?.edges?.map((edge) => edge.node) ?? [],
  mapPagination: (data: LocationSelectorFormFieldQuery) => ({
    total: data.locations?.locationsConnection?.totalCount ?? 0,
    cursor: data.locations?.locationsConnection?.pageInfo?.endCursor ?? undefined,
    hasNextPage: data.locations?.locationsConnection?.pageInfo?.hasNextPage ?? false,
  }),
})

export const useLocationSelectorSource = () => {
  return useGraphqlDataSource(locationSelectorSourceDefinition)
}
